export default "__VITE_ASSET__CEU2nrXa__"